import { FC, Suspense } from 'react';
import { PageContainer } from 'src/components/layout';
import { PageContainerProps } from 'src/components/layout/page/types';
import { LoadingScreen } from 'src/components/others/LoadingScreen';

export const LazyLoader = (Component: FC) => (props: PageContainerProps) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <PageContainer {...props}>
        <Component />
      </PageContainer>
    </Suspense>
  );
};
